import { reactive, provide } from 'vue';
export const ToggleInjectionKey = Symbol('toggle');

export default {
    name: 'ToggleContainer',
    props: {
        showExpanded: { type: Boolean, default: false },
    },
    setup(props, { slots }) {
        const state = reactive({
            isActive: props.showExpanded,
            containerEl: null,
        });

        const api = {
            state,
            expand() {
                state.isActive = true;
            },
            collapse() {
                state.isActive = false;
            },
            toggle() {
                state.isActive = !state.isActive;
            },
            setContainerEl(el) {
                state.containerEl = el;
            },
        };

        provide(ToggleInjectionKey, api);

        // Renderless: render the slot as a fragment so no extra DOM element is introduced.
        return () => slots.default?.();
    },
};
